import React from 'react';
import PropTypes from 'prop-types';

import Dropdown from '../../Dropdown';
import {
  isRequired
} from 'utilities/validators.js';

const RowData = ({ numericalOptionsDataset, categoricalOptionsDataset, isSummaryDataTab }) =>
  <>
    <Dropdown
      isClearable
      optionsList={numericalOptionsDataset}
      label="Responses"
      name="numericalRowDataSetAnova"
      id="numericalRowDataSetAnova"
      placeholder="Select a Variable"
      validate={isRequired}
      isDisabled={!isSummaryDataTab}
    />
    <Dropdown
      isClearable
      optionsList={categoricalOptionsDataset}
      label="Factors"
      name="categoricalRowDataSetAnova"
      id="categoricalRowDataSetAnova"
      placeholder="Select a Variable"
      validate={isRequired}
      isDisabled={!isSummaryDataTab}
    />
  </>;

RowData.propTypes = {
  numericalOptionsDataset: PropTypes.array.isRequired,
  categoricalOptionsDataset: PropTypes.array.isRequired,
  isSummaryDataTab: PropTypes.bool.isRequired
};

export default RowData;
